import React from 'react';
import PropTypes from 'prop-types';

export function StageTabBar({ tabs, value, onChange }) {
  return (
    <nav className="onyx-stage-tabs" data-testid="onyx-stage-tabs" aria-label="Lighthouse stages">
      {tabs.map((tab) => {
        const active = tab.id === value;
        const badge = tab.badge;
        const showBadge = badge != null && Number(badge) > 0;
        return (
          <button
            key={tab.id}
            type="button"
            className={`onyx-stage-tabs__tab${active ? ' onyx-stage-tabs__tab--active' : ''}`}
            aria-current={active ? 'page' : undefined}
            aria-label={
              showBadge
                ? `${tab.label}, ${badge} ${tab.badgeLabel || 'items'}`
                : tab.label
            }
            onClick={() => onChange(tab.id)}
          >
            <span className="onyx-stage-tabs__label">{tab.label}</span>
            {showBadge ? (
              <span className="onyx-stage-tabs__badge" data-testid={`onyx-stage-badge-${tab.id}`}>
                {badge}
              </span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
}

StageTabBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      badge: PropTypes.number,
      badgeLabel: PropTypes.string,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
